import { render, staticRenderFns } from "./ProductCreationModal.vue?vue&type=template&id=5fefde6a&"
import script from "./ProductCreationModal.vue?vue&type=script&lang=js&"
export * from "./ProductCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports